// Whether an element's text is visually cut off, re-measured when its box or the window changes size.

import { useCallback, useEffect, useLayoutEffect, useState } from 'react'

export const useClipped = (ref, text) => {
  const [clipped, setClipped] = useState(false)

  const measure = useCallback(() => {
    const node = ref.current
    if (!node) return
    setClipped(node.scrollWidth > node.clientWidth)
  }, [ref])

  useLayoutEffect(() => {
    measure()
  }, [text, measure])

  useEffect(() => {
    const node = ref.current
    if (!node) return undefined
    window.addEventListener('resize', measure)
    let observer = null
    if (typeof window.ResizeObserver === 'function') {
      observer = new window.ResizeObserver(measure)
      observer.observe(node)
    }
    return () => {
      window.removeEventListener('resize', measure)
      if (observer) observer.disconnect()
    }
  }, [ref, measure])

  return clipped
}
